import { render, staticRenderFns } from "./BreakCount.vue?vue&type=template&id=f204c13a&scoped=true"
import script from "./BreakCount.vue?vue&type=script&lang=js"
export * from "./BreakCount.vue?vue&type=script&lang=js"
import style0 from "./BreakCount.vue?vue&type=style&index=0&id=f204c13a&prod&lang=scss"
import style1 from "./BreakCount.vue?vue&type=style&index=1&id=f204c13a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f204c13a",
  null
  
)

export default component.exports